/**
 * SISTEMA: PGLP | MONTE HERMOM
 * SERVIÇO: LaudoGoogleDriveService_Soberano
 * STATUS: 100% INTEGRAL - REGRA DE CUSTÓDIA DINÂMICA
 */

import axios from 'axios';

/**
 * Executa o protocolo de custódia enviando o laudo para o Google Drive da conta pglaudopericial@gmail.com
 */
export const executarCustodiaCloud = async (laudoData, requerente, contextoSessao) => {
    // Definição dinâmica de destino baseada no processo
    const folderName = `PROCESSO_${requerente.processoJudicial.replace(/\//g, '-')}`;
    const fileName = `LAUDO_TECNICO_${requerente.cpfCnpj || 'S_DOC'}_${Date.now()}.pdf`;

    // Extração de Metadados Dinâmicos (Sessão do Perito)
    const metadataSovereign = {
        perito: contextoSessao?.nomePerito || "MARCUS FERRAZ",
        crea_cau: contextoSessao?.registroProfissional || "REGISTRO_NÃO_INFORMADO",
        norma: contextoSessao?.normaAplicada || "NBR 14653-2",
        hashIntegridade: laudoData.hash,
        dataFechamento: new Date().toISOString(),
        empresa: "MONTE HERMOM DIGITAÇÃO LTDA"
    };

    console.log(`%c [MONTE HERMOM] Iniciando Protocolo de Lacre para: ${fileName} `, 'background: #0f172a; color: #3b82f6; font-weight: bold;');

    try {
        // Chamada à API SaaS (Backend que faz o handshake com Google Cloud Console)
        const response = await axios.post('/api/saas/custodia/google-drive', {
            folderName,
            fileName,
            payload: laudoData,
            metadata: metadataSovereign
        });

        if (response.status === 200 || response.status === 201) {
            return {
                success: true,
                driveLink: response.data.webViewLink,
                fileId: response.data.id,
                statusEspaco: response.data.quotaUsage // Monitor de % do Drive
            };
        }
        return { success: false, error: "Status de resposta inesperado da API." };
    } catch (error) {
        console.error("ERRO CRÍTICO NA CUSTÓDIA CLOUD:", error);
        return { 
            success: false, 
            error: error.response?.data?.message || "Falha na comunicação com a Google Cloud API." 
        };
    }
};

/**
 * Monitor de Quota Soberana: Verifica se a conta pglaudopericial@gmail.com está cheia
 */
export const verificarCotaSovereign = async () => {
    try {
        const response = await axios.get('/api/saas/drive/quota');
        return response.data; // Retorna { limit, usage, remainingPercent }
    } catch (error) {
        console.error("Erro ao verificar quota do Drive.");
        return null;
    }
};